
export enum DriverJobTypeCd {
	BID = 'Bid',
	FLEX = 'Flex'}

